module.exports = "/static/assets/667c72a022edc70581e65852f5d95ad8.png";